// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3p42y","title":"Info_title__1n9aZ","links":"Info_links__2hKCi","link":"Info_link__2Lf4a","logo":"Info_logo__3IIGg"};